import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'
import type { ExistingOrderState } from '../states/useExistingOrder/types'
import { emptyExistingOrderState } from '../states/useExistingOrder/types'

interface ExistingOrderStoreState {
  existingOrder: ExistingOrderState
  setExistingOrder: (value: ExistingOrderState) => void
  resetExistingOrder: () => void
}

export const useExistingOrderStore = create<ExistingOrderStoreState>()(
  devtools(
    immer((set) => ({
      existingOrder: emptyExistingOrderState,
      setExistingOrder: (value) => {
        set({ existingOrder: value })
      },
      resetExistingOrder: () => {
        set({ existingOrder: emptyExistingOrderState })
      },
    })),
    { name: 'existing-order-store' },
  ),
)

export const useExistingOrderState = () => useExistingOrderStore((state) => state.existingOrder)
